import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import gsap from "gsap";

export const otherCtaBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.other-cta', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const bgMob = section.querySelector('.other-cta__background-mob');

    const createTruckAnim = () => {
        if (!_state.isDesktop && bgMob) {
            bgMob.style.setProperty('--section-height', section.clientHeight + 'px');
        }
    }

    createTruckAnim();

    const rebuildFunc = () => {
        createTruckAnim();
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}